import type { ReactNode } from "react";
import { SweepButton } from "@softmax/design-system";
import { fieldLabel, bodyText } from "./profile-styles";

export function LinkedAccount({
  title,
  body,
  action,
}: {
  title: string;
  body: ReactNode;
  action: { label: string; onClick: () => void } | null;
}) {
  return (
    <div className="flex flex-col gap-[4px]">
      <h3 className={fieldLabel}>{title}</h3>
      <p className={bodyText}>{body}</p>
      {action ? (
        <SweepButton
          quiet
          type="button"
          focus="ring"
          placement="start-spaced"
          onClick={action.onClick}
        >
          {action.label}
        </SweepButton>
      ) : null}
    </div>
  );
}
